import { b } from './chunk-5HWZQ4DE.js';
import { jsxs, jsx } from 'react/jsx-runtime';

function m(t){let{decimalPlaces:i,payload:e}=t;if(!e||e.length===0)return null;let{payload:r}=e[0],{title:n,colour:d,tooltipTitle:c,value:s}=r;return jsxs("div",{className:"m-0 whitespace-nowrap border border-solid border-[rgb(204,204,204)]  bg-white p-2",children:[jsxs("div",{className:"flex items-center",children:[jsx("span",{className:"me-1 inline-block h-4 w-4",style:{backgroundColor:d}}),c||n]}),jsx("div",{children:b(String(s.toFixed(i)))})]})}

export { m as a };
//# sourceMappingURL=out.js.map
//# sourceMappingURL=chunk-Z4UKW732.js.map